import type { IOutcomeConsensus } from "~/types/event";

export const getHiddenMarketsNote = ({
  marketCount,
  matchingMarketCount,
}: Pick<IOutcomeConsensus, "marketCount" | "matchingMarketCount">):
  string | null => {
  const hidden = marketCount - matchingMarketCount;

  if (hidden <= 0) {
    return null;
  }

  const [noun, pronoun] = hidden === 1 ? ["market", "it"] : ["markets", "them"];

  return `${hidden} ${noun} hidden by your filters. PH Consensus still includes ${pronoun}.`;
};
